export function quoteReducer(state = {
    SALES : {},
    REAPPRO : {},
    REAPPRO_EXT : {},
    REA_DRAFTS : {},
    DEVIS : {},
    QUOTES : {},
    ALL: {}
},{
    type,
    payload
}){
    
    switch(type){
        case "NEW_QUOTE":  
            let list = Object.assign({}, state)
            list.ALL = {[payload.id] : payload, ...list.ALL}
            list.QUOTES = {[payload.id] : payload, ...list.QUOTES}
           
            return list

        case "UPDATE_QUOTE":  
            let list2 = Object.assign({}, state)
            list2.ALL[payload.id] = payload
            list2.QUOTES[payload.id] = payload
            
            return list2
            
        case "GET_QUOTES":
            let quotes = Object.assign({}, state)
            quotes.QUOTES = payload
            return quotes

        case "GET_QUOTE":
            return payload;

        default:
            return state;
    }
    
}